/**
 * Error thrown when the user is not a member of the requested team office.
 */
export class TeamOfficeForbiddenError extends Error {
  constructor(message = "You are not a member of this office") {
    super(message);
    this.name = "TeamOfficeForbiddenError";
    Object.setPrototypeOf(this, TeamOfficeForbiddenError.prototype);
  }
}

export type FeatureNotAvailableReason =
  | "starter_default_office_only"
  | (string & {});

/**
 * Error thrown when an office is unavailable for the current plan.
 */
export class FeatureNotAvailableError extends Error {
  reason: FeatureNotAvailableReason | null;

  constructor(
    message = "This office is not available on your current plan",
    reason: FeatureNotAvailableReason | null = null
  ) {
    super(message);
    this.name = "FeatureNotAvailableError";
    this.reason = reason;
    Object.setPrototypeOf(this, FeatureNotAvailableError.prototype);
  }
}
